import React from 'react';

const Contact = () => {
  return (
    <React.Fragment>
      <section id='contact'>
        <div className='inner'>
          <section>
            <h2>Get In Touch</h2>
            <form method='post' action='#'>
              <div className='fields'>
                <div className='field half'>
                  <label htmlFor='name'>Name</label>
                  <input type='text' name='name' id='name' />
                </div>
                <div className='field half'>
                  <label htmlFor='tel'>Phone</label>
                  <input type='text' name='phone' id='phone' />
                </div>
                <div className='field'>
                  <label htmlFor='email'>Email</label>
                  <input type='text' name='email' id='email' />
                </div>
                <div className='field'>
                  <label htmlFor='message'>Message</label>
                  <textarea name='message' id='message' rows='6'></textarea>
                </div>
              </div>
              <ul className='actions'>
                <li>
                  <input type='submit' value='Send Message' className='primary' />
                </li>
                <li>
                  <input type='reset' value='Clear' />
                </li>
              </ul>
            </form>
          </section>
          <section className='split'>
            <section>
              <div className='contact-method'>
                <span className='icon solid alt fa-envelope'></span>
                <h3>Email</h3>
                <span>forlarbomi@gmail.com</span>
              </div>
            </section>
            <section>
              <div className='contact-method'>
                <span className='icon solid alt fa-phone'></span>
                <h3>Phone</h3>
                <span>+234-903-3741-379</span>
              </div>
            </section>
            <section>
              <div className='contact-method'>
                <span className='icon solid alt fa-home'></span>
                <h3>Address</h3>
                <span>
                  Phase 2, Site 1, Lagos Crescent
                  <br />
                  Kubwa 900287 CN,
                  <br />
                  Abuja Nigeria
                </span>
              </div>
            </section>
          </section>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Contact;
